"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainTheme = void 0;
const inventory_1 = require("./inventory");
exports.mainTheme = {
  colors: inventory_1.GENERAL_COLOR_VALUES,
  fontSizes: inventory_1.FONT_SIZES,
  fontWeights: inventory_1.GENERAL_FONT_WEIGHT_VALUES,
  lineHeights: inventory_1.LINE_HEIGHTS,
  spacing: inventory_1.SPACING_SIZES,
  fontNames: inventory_1.GENERAL_FONT_VALUES
};